<template>
	<div class="condition-single">
		<div>
			<select class="qd-dropdown field-dropdown" v-model="localData.field">
				<option v-for="field in fields.filter(x => !x.fromVariable)" :key="field.path" :value="field.path">
					{{ field.title }}
				</option>
			</select>
		</div>
		<div>
			<select class="qd-dropdown condition-dropdown" v-model="localData.condition">
				<option v-for="ct in conditionTypes" :key="ct.value" :value="ct.value">
					{{ ct.title }}
				</option>
			</select>
		</div>
		<div>
			<condition-value v-model="conditionValue" @update:modelValue="conditionValueChanged" :col="col" :fields="fields" :variables="variables" />
		</div>
	</div>
</template>

<script>

	const STRING_ITEMS = [
		{
			title: 'برابر باشد با',
			value: '=',
		},
		{
			title: 'برابر نباشد با',
			value: '!=',
		},
		{
			title: 'شروع شود با',
			value: 'starts with',
		},
		{
			title: 'شروع نشود با',
			value: 'not starts with',
		},
		{
			title: 'پایان یابد با',
			value: 'ends with',
		},
		{
			title: 'پایان نیابد با',
			value: 'not ends with',
		},
		{
			title: 'شامل باشد',
			value: 'contains',
		},
		{
			title: 'شامل نباشد',
			value: 'not contains',
		},
		{
			title: 'در لیست باشد',
			value: 'IN',
		},
		{
			title: 'در لیست نباشد',
			value: 'NOT IN',
		},
	]
	const NUMBER_ITEMS = [
		{
			title: 'برابر باشد با',
			value: '=',
		},
		{
			title: 'برابر نباشد با',
			value: '!=',
		},
		{
			title: 'بزرگتر باشد از',
			value: 'greatr than',
		},
		{
			title: 'بزرگتر مساوی باشد از',
			value: 'greatr equal than',
		},
		{
			title: 'کوچکتر باشد با',
			value: 'less than',
		},
		{
			title: 'کوچکتر مساوی باشد با',
			value: 'less equal than',
		},
		{
			title: 'در لیست باشد',
			value: 'IN',
		},
		{
			title: 'در لیست نباشد',
			value: 'NOT IN',
		},
	]
	export default {
		props: {
			modelValue: {
				type: Object,
			},
			fields: {
				type: Array,
			},
			variables: {
				type: Array,
				default: () => [],
			},
		},
		emits: ['update:modelValue'],
		data() {
			return {
				col: null,
				conditionValue: {},
				localData: {
					field: '',
					condition: '',
					value: '',
					type: '',
					key: '',
				},
			}
		},
		watch: {
			localData: {
				deep: true,
				handler(val) {
					if (val) {
						let col = this.fields?.find(x => x.path === val.field)
						this.col = col
					}
					this.$emit('update:modelValue', this.localData)
				},
			},
		},
		created() {
			this.localData = { ...this.modelValue }
			this.conditionValue = { ...this.modelValue }
		},
		computed: {
			variableItems() {
				let items = []
				let mapped = this.variables.map((v) => {
					return {
						title: v.name,
						value: v.name,
					}
				})
				if (mapped.length) items.push(...mapped)
				return items
			},
			reportParameterItems() {
				let items = []
				let mapped = this.reportParameters.map((v) => {
					return {
						title: v.name,
						value: v.name,
					}
				})
				if (mapped.length) items.push(...mapped)
				return items
			},
			entityFields() {
				return {}
			},
			conditionTypes() {
				if (!this.col)
					return []
				let type = this.col.type
				if (this.col.aggregate)
					type = 'int'
				switch (type.toLowerCase()) {
					case 'int':
					case 'decimal':
					case 'datetime':
						return NUMBER_ITEMS
					case 'guid':
					case 'string':
					default:
						return STRING_ITEMS
				}
			},
		},
		methods: {
			conditionValueChanged(value) {
				this.localData.type = value.type
				this.localData.value = value.value
				this.localData.key = value.key
			},
		},
	}
</script>

<style></style>